import $ from 'jquery'

$(document).ready(() => {
  // just defining this applies the correct validation and blocks empty forms from submitting
  $('#search').validate({})
})
